import React, { FC } from 'react';

import { getGrade } from '../../../../helpers/grading';
import { usePricing } from '../../../../data-hooks/pricing';
import { useWizard } from '../../../../contexts/WizardContext';
import { buildRegionPricing } from '../../../../helpers/pricing';
import TableField from './TableField';
import ZotaLoader from '../../../shared/ZotaLoader';

interface DynamicTableRegionProps {
  region: string;
}

export const DynamicTableRegion: FC<DynamicTableRegionProps> = ({ region }) => {
  const { data } = useWizard();
  const grade = getGrade(data);
  const { pricing, isLoading } = usePricing(region, grade);

  if (isLoading) {
    return <ZotaLoader/>;
  }

  if (!pricing) {
    return <ZotaLoader/>;
  }

  const regionPricing = buildRegionPricing(pricing, '200 EU');

  return (
    <table>
      <tbody>
        <tr>
          <td colSpan={region === 'Latam' ? 3 : 2} className='table-title-box'>
            <p>Set up fee per bank Merchant ID (MID)</p>
          </td>
          <td className='table-price-box'>
          <span className='table-price'>{regionPricing.setupFee}</span>
          </td>
        </tr>

        <TableField name='Merchant Discount Rate' fieldPricing={regionPricing.merchantDiscountRate}/>
        <TableField name='Transaction Fee' fieldPricing={regionPricing.transactionFee}/>
        <TableField name='Payouts' fieldPricing={regionPricing.payouts}/>
        <TableField name='Credit Fee' fieldPricing={regionPricing.creditFee}/>
        <TableField name='Chargeback Handling Fee' fieldPricing={regionPricing.chargebackHandlingFee}/>
        <TableField name='Rolling Reserve' fieldPricing={regionPricing.rollingReserve}/>
      </tbody>
    </table>
  );
};